export default () => ({
  statuses: [],
  requests: [],
  tools: [],
  techs: [],
  userInfo: null
})



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/state.js